import { MarketplaceVendorsCategory } from '@shared/types/marketplace';

export const vendorCategoryColors: Record<string, string> = {
  Accounting: '#064E46', // Green
  Banking: '#0C064E', // Dark Blue
  'Billing & Invoicing': '#E39F00', // Orange
  Payroll: '#6B6B6B', // Gray
  'Expense Management': '#00CCD9', // Cyan
  'Misc.': '#242424', // Dark Gray
};

export const getVendorCategoryColor = (
  category: MarketplaceVendorsCategory
): string => {
  return vendorCategoryColors[category];
};
